/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import config from '../coreFIles/config'
import Header from '../directives/header'
import { TwitterShareButton, TwitterIcon, FacebookShareButton, FacebookIcon, TelegramShareButton, TelegramIcon, RedditShareButton, RedditIcon, WhatsappShareButton, WhatsappIcon } from 'react-share';
import 'react-accessible-accordion/dist/fancy-example.css';
import moment from 'moment';
import { getuserBlogidAction, getRecentuserBlogidAction } from '../Action/user.action';
import { Col, Row } from 'react-bootstrap';
import Footer from './Mrmintnew/directives/footer';
const Blogdetail = () => {
    const [getblogidlist, setBlogid] = useState({});
    const [getRecntuserbloglist, setuserRecentBlogList] = useState([]);
    const [form, setForm] = useState({ id: '', image: '', previewImage: '', title: '', description: '' });
    useEffect(() => {
        getblogid();
        getRecentuserBlog();
    }, []);

    const getblogid = async () => {
        const id = window.location.href.split("/").pop();
        let res = await getuserBlogidAction({ 'id': id });
        if (res.success) {
            setBlogid(res.data)
            let data = res.data[0];
            setForm((old) => {
                return { ...old, "id": id, 'previewImage': config.imageUrl + data.image, 'title': data.title, 'introduction': data.introduction, 'description': data.description, 'created_at': data.created_at }
            })
        }
    }
    const getRecentuserBlog = async () => {
        let res = await getRecentuserBlogidAction();
        if (res.success) {
            setuserRecentBlogList(res.data)
        }
    }
    
    return (
        <>
            <Header />
            <div id="content">
                <div className="breadcrumb-wrap bg-f br-4">
                    <div className="overlay bg-black op-7" />
                    <div className="container">
                        <div className="breadcrumb-title">
                            <h2 className='blog_font text-center'>{form.title}</h2>
                            <p className='text-center'>Written By Mr Mint {form.created_at}</p>
                            <ul className="breadcrumb-menu list-style mt-2 text-center">
                                <li>
                                    <a href="#">Home</a>
                                </li>
                                <li>Blog Detail</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section className="mr-blog-details pt-5">
                    <div className="container">
                        {/* <div className="row gx-5">
                            <div className='col-sm-12 col-md-12 mb-3'>
                                <div dangerouslySetInnerHTML={{ __html: form.introduction }} />
                            </div>

                            <div className="col-sm-8 col-md-8">
                                <div className='mr-blog-informations'>
                                    <div className='mr-imgboxs-block'>
                                        <div className='mr-imgbox-inner'>
                                            <img src={form.previewImage} alt="Image" />
                                        </div>
                                    </div>
                                    <div className='mr-blog-contents mb-2'>
                                        <p>
                                            <div dangerouslySetInnerHTML={{ __html: form.description }} />
                                        </p>
                                        <br />
                                    </div>

                                    <div className="mr-post-meta-option">
                                        <span>
                                            Share this post on social networks
                                        </span>
                                        <ul className="mr-social-profile">


                                            <TelegramShareButton
                                                url={window.location.href}
                                                title={form.title}
                                                className="Demo__some-network__share-button">
                                                <TelegramIcon
                                                    size={32}
                                                    round />
                                            </TelegramShareButton> &nbsp;

                                            <FacebookShareButton
                                                url={window.location.href}
                                                title={form.title}
                                                className="Demo__some-network__share-button">
                                                <FacebookIcon
                                                    size={32}
                                                    round />
                                            </FacebookShareButton> &nbsp;

                                            <TwitterShareButton
                                                url={window.location.href}
                                                title={form.title}
                                                className="Demo__some-network__share-button">
                                                <img src="images/twitterxbluelogo.png" alt='twitter' height={32} />
                                            </TwitterShareButton> &nbsp;


                                            <RedditShareButton
                                                url={window.location.href}
                                                title={form.title}
                                                className="Demo__some-network__share-button">
                                                <RedditIcon
                                                    size={32}
                                                    round />
                                            </RedditShareButton> &nbsp;


                                            <WhatsappShareButton
                                                url={window.location.href}
                                                title={form.title}
                                                className="Demo__some-network__share-button">
                                                <WhatsappIcon
                                                    size={32}
                                                    round />
                                            </WhatsappShareButton>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-4 col-md-4">
                                <div className="mr-blogrecent-block">
                                    <h4 className='mr-recent-title'>
                                        Recent Posts
                                    </h4>

                                    <div className='mr-blogrecent-list'>
                                        {getRecntuserbloglist.map(data => (
                                            <div className='media mr-blogrecent-item'>
                                                <div className='mr-imgboxs-block'>
                                                    <img src={`${config.imageUrl + data.image}`} alt="Image" />
                                                </div>
                                                <div className="mr-blogrecent-content">
                                                    <h6>
                                                        <a href={`${config.baseUrl}Blog/` + data.title_url} className='links'>
                                                            {data.title}
                                                        </a>
                                                    </h6>
                                                    <span className='time'>
                                                        {moment(data.datetime).format('DD/MM/YYYY')}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <Row>
                            <Col lg={12}>
                                <div className='mb-4'>
                                    <div dangerouslySetInnerHTML={{ __html: form.introduction }} />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className='mr-blog-informations'>
                                    <div className='mr-imgboxs-block'>
                                        <div className='mr-imgbox-inner'>
                                            <img src={form.previewImage} alt="Image" />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mr-blogrecent-block">
                                    <h4 className='mr-recent-title blog_font'>
                                        Recent Posts
                                    </h4>

                                    <div className='mr-blogrecent-list'>
                                        {getRecntuserbloglist.map(data => (
                                            <div className='media mr-blogrecent-item'>
                                                <div className='mr-imgboxs-block'>
                                                    <img src={`${config.imageUrl + data.image}`} alt="Image" />
                                                </div>
                                                <div className="mr-blogrecent-content">
                                                    <h6 className='blog_font'>
                                                        <a href={`${config.baseUrl}Blog/` + data.title_url} className='links'>
                                                            {data.title}
                                                        </a>
                                                    </h6>
                                                    <span className='time'>
                                                        {moment(data.datetime).format('DD/MM/YYYY')}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div className='mr-blog-informations'>
                                    <div className='mr-blog-contents mb-2'>
                                        <p>
                                            <div dangerouslySetInnerHTML={{ __html: form.description }} />
                                        </p>
                                        <br />
                                    </div>

                                    <div className="mr-post-meta-option">
                                        <span>
                                            Share this post on social networks
                                        </span>
                                        <ul className="mr-social-profile">


                                            <TelegramShareButton
                                                url={window.location.href}
                                                title={form.title}
                                                className="Demo__some-network__share-button">
                                                <TelegramIcon
                                                    size={32}
                                                    round />
                                            </TelegramShareButton> &nbsp;

                                            <FacebookShareButton
                                                url={window.location.href}
                                                title={form.title}
                                                className="Demo__some-network__share-button">
                                                <FacebookIcon
                                                    size={32}
                                                    round />
                                            </FacebookShareButton> &nbsp;

                                            <TwitterShareButton
                                                url={window.location.href}
                                                title={form.title}
                                                className="Demo__some-network__share-button">
                                                <img src="images/twitterxbluelogo.png" alt='twitter' height={32} />
                                            </TwitterShareButton> &nbsp;


                                            <RedditShareButton
                                                url={window.location.href}
                                                title={form.title}
                                                className="Demo__some-network__share-button">
                                                <RedditIcon
                                                    size={32}
                                                    round />
                                            </RedditShareButton> &nbsp;


                                            <WhatsappShareButton
                                                url={window.location.href}
                                                title={form.title}
                                                className="Demo__some-network__share-button">
                                                <WhatsappIcon
                                                    size={32}
                                                    round />
                                            </WhatsappShareButton>
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    )

}
export default Blogdetail;